<div class="card card-statistics mb-30" [hidden]="Switcher_form=='Check'">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات مرخصی روزانه</h5>
    <form [formGroup]="AddNewOffday" (submit)="CheckOffday()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">از تاریخ </label>
          <input formControlName="startDate" #vaziat_startDateInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تا تاریخ </label>
          <input formControlName="endDate" #vaziat_endDateInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_Person(templatePerson)"
              class="btn btn-danger left"> انتخاب جایگزین<i class="fa fa-user"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.fullname}}" />
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح </label>
          <input formControlName="dsc" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_dsc().valid && get_Form_dsc().touched"
            class="form-text text-muted MyErrorRedColor">شرح را وارد نمائید.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewOffday.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> بررسی اطلاعات مرخصی </button>
      <button routerLink="/Offday" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>

<div class="card card-statistics mb-30" [hidden]="Switcher_form=='Insert'">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات مرخصی روزانه</h5>
    <form [formGroup]="AddNewOffday" (submit)="CheckOffday()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ شروع </label>
          <input disabled type="text" value="{{startDate_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ پایان </label>
          <input disabled type="text" value="{{endDate_fulldate}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> جایگزین </label>
          <input disabled type="text" value="{{Data_Seleted_Record.fullname}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> روز کاری </label>
          <input disabled type="text" value="{{on}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> روز تعطیل </label>
          <input disabled type="text" value="{{off}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح </label>
          <input disabled type="text" value="{{get_Form_dsc().value}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="button" (click)="SubmitAddNewOffday()" [disabled]="!AddNewOffday.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> تایید و ثبت اطلاعات </button>
      <button *ngIf="!InProccessing" type="button" (click)="set_Switcher_form('Insert')" class="btn btn-danger"
        style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو </button>
      <button routerLink="/Offday" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>



<ng-template #templatePerson>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات پرسنل </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> نام و نام خانوادگی</label>
          <input type="text" class="form-control" [(ngModel)]="Search_Name_Person_Table"
            placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Person
            |filter:Search_Name_Person_Table:'fullname'
            | paginate
                    : {
                        id: 'DataList_Person',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Person|filter:Search_Name_Person_Table:'fullname').length
                      }">
              <td>{{DataList_Person.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td (click)="Set_Selected_Person_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingPerson" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingPerson" type="button" (click)="ReadData_Person()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">بستن</button>
  </div>
</ng-template>